import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "7", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "15 18 21 12 15 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 5v14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowRightFromLine";
const ArrowRightFromLine = memo(themed(Icon));
export {
  ArrowRightFromLine
};
//# sourceMappingURL=arrow-right-from-line.js.map
